import { useWide } from '@/platform/useWide';
import styles from './SceneWords.module.css';

const WORDS = [
  { w: 'компот',    top: '4%',  left: '21%', size: 22, op: 0.055, dur: 17, dx: 18,  dy: 12  },
  { w: 'кровать',   top: '7%',  left: '79%', size: 24, op: 0.06,  dur: 18, dx: -16, dy: 14  },
  { w: 'косточка',  top: '91%', left: '35%', size: 22, op: 0.05,  dur: 20, dx: 16,  dy: -12 },
  { w: 'компьютер', top: '93%', left: '65%', size: 24, op: 0.055, dur: 24, dx: -14, dy: -14 },
  { w: 'кофта',     top: '52%', left: '94%', size: 22, op: 0.06,  dur: 19, dx: -16, dy: 16  },
  { w: 'коготь',    top: '25%', left: '6%',  size: 20, op: 0.05,  dur: 22, dx: -14, dy: 17  },
  { w: 'капот',     top: '76%', left: '50%', size: 20, op: 0.05,  dur: 20, dx: -14, dy: -12 },
];

export function SceneWords() {
  const isWide = useWide(1100);
  if (!isWide) return null;

  return (
    <div className={styles.layer} aria-hidden="true">
      {WORDS.map((d, i) => (
        <div
          key={d.w}
          className={styles.word}
          style={{
            top: d.top,
            left: d.left,
            opacity: d.op,
            fontSize: d.size + 'px',
            '--dx': d.dx + 'px',
            '--dy': d.dy + 'px',
            animationDuration: d.dur + 's',
            animationDelay: -(i * 1.7) + 's',
          } as React.CSSProperties}
        >
          {d.w}
        </div>
      ))}
    </div>
  );
}
